<template>
  <nav class="ecl-tabs mb-0">
    <div class="ecl-tabs__container">
      <ul class="ecl-tabs__list pl-0" role="tablist">
        <li class="ecl-tabs__item" role="presentation">
          <router-link class="block ecl-link ecl-tabs__link" role="tab" exact
                       :to="{ name: 'DataProvision' }"
                       active-class="ecl-tabs__link--active">
            Data Provision
          </router-link>
        </li>
        <li class="ecl-tabs__item" role="presentation">
          <router-link class="block ecl-link ecl-tabs__link" role="tab"
                       :to="{ name: 'Editor' }"
                       active-class="ecl-tabs__link--active">
            Editor
          </router-link>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  name: "MainTabs"
}
</script>

<style scoped>

</style>
